/* Custom-kit request form. Loaded by sections/custom-kit-form.liquid.
   ?product= / ?sku= prefill Product and Size on the native form and, when a
   Shopify Forms @app block is present, via pfFormsApp (same labels as forms_spec). */
(function () {
  'use strict';

  var p = new URLSearchParams(window.location.search);
  var product = p.get('product');
  var sku = p.get('sku');
  var app = document.querySelector('[data-kit-app]');
  if (app) {
    if ((product || sku) && window.pfFormsApp) {
      window.pfFormsApp.ready(app, function (root) {
        if (product) {
          var el = window.pfFormsApp.control(root, 'Product');
          if (el) window.pfFormsApp.fill(el, product);
        }
        if (sku) {
          var el = window.pfFormsApp.control(root, 'Size');
          if (el) window.pfFormsApp.fill(el, sku);
        }
      });
    }
    return;
  }
  var form = document.getElementById('KitForm');
  if (!form) return;
  if (product) {
    var prod = form.querySelector('[data-kit-product]');
    if (prod) prod.value = product;
  }
  if (sku) {
    var size = form.querySelector('[data-kit-sku]');
    if (size) size.value = sku;
  }
})();
